module.exports = __webpack_public_path__ + "img/vue1-corpsavant_bleu.60aacca0.png";